import * as React from 'react';

import styled from '@emotion/styled';
import { Box, Flex } from '@lightspeed/flame/Core';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { IconTools } from '@lightspeed/flame/Icon/Tools';
import { Switch } from '@lightspeed/flame/Switch';
import { Text } from '@lightspeed/flame/Text';

import { ClassType } from 'root/apps/TaxClassForm/types';

const HelpText = styled(Text)`
  color: ${theme.colors['gray-400']};
  margin-top: 10px;
  max-width: 500px;
`;

export interface TaxClassServiceTypeToggleProps {
  type: ClassType;
  typeInputElement: HTMLInputElement;
  isLastLaborClass: boolean;
}

export const TaxClassServiceTypeToggle: React.FC<TaxClassServiceTypeToggleProps> = ({
  type: _type,
  typeInputElement,
  isLastLaborClass,
}) => {
  const [type, setType] = React.useState(_type);

  React.useEffect(() => {
    typeInputElement.value = type;
  }, [typeInputElement, type]);

  const handleChange = () => {
    setType(type === ClassType.service ? ClassType.item : ClassType.service);
    if (window.viewFieldChanged) window.viewFieldChanged('view');
  };

  const checked = type === ClassType.service;

  return (
    <Flex justifyContent="flex-start" maxWidth="100%" flexDirection="column">
      <Flex alignItems="center">
        <Box className="label">
          <IconTools />
          <label style={{ marginLeft: '5px' }}>Service line item</label>
        </Box>
        <Switch
          checked={checked}
          onChange={handleChange}
          data-test="classTypeSwitch"
          disabled={isLastLaborClass}
        />
      </Flex>
      <HelpText>
        Apply this tax class specifically for items used in work orders. Turning this on ensures
        that functionalities associated with service items are activated.
      </HelpText>
    </Flex>
  );
};
